module.exports = __webpack_public_path__ + "static/media/new-products-item-2.47801c8f.png";